import React, { useState, useRef } from 'react';
import { storage } from '../../config/firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export default function ImageUpload({
    weddingId,
    eventId,
    user,
    onUploadComplete,
    onShowAiGenerator,
    buttonText = "Upload Image",
    hideLabel = false
}) {
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState('');
    const fileInputRef = useRef(null);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!user) {
            setError("You must be logged in to upload images.");
            return;
        }

        setIsUploading(true);
        setError('');

        try {
            // Determine path based on whether it's a wedding site or an evite
            const pathPrefix = weddingId ? `wedding-sites/${weddingId}` : `evites/${eventId || 'general'}`;
            const filePath = `${pathPrefix}/${user.uid}/${Date.now()}_${file.name}`;
            
            const fileRef = ref(storage, filePath);
            await uploadBytes(fileRef, file);
            const url = await getDownloadURL(fileRef);
            
            if (onUploadComplete) {
                onUploadComplete(url);
            }
        } catch (err) {
            console.error("Upload error:", err);
            setError("Failed to upload image. Please try again.");
        } finally {
            setIsUploading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    return (
        <div className="w-full">
            {!hideLabel && (
                <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-2">
                    Upload or Generate Image
                </label>
            )}
            <div className="flex flex-col sm:flex-row gap-3">
                <button
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                    disabled={isUploading}
                    className="flex-1 bg-white border-2 border-dashed border-gray-300 text-gray-700 font-bold py-2 px-4 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition shadow-sm disabled:opacity-50 whitespace-nowrap"
                >
                    {isUploading ? 'Uploading...' : buttonText}
                </button>
                
                {onShowAiGenerator && (
                    <button
                        type="button"
                        onClick={onShowAiGenerator}
                        disabled={isUploading}
                        className="flex-1 bg-purple-50 border border-purple-200 text-purple-700 font-bold py-2 px-4 rounded-lg hover:bg-purple-100 transition shadow-sm flex items-center justify-center gap-2 whitespace-nowrap"
                    >
                        ✨ AI Generate
                    </button>
                )}
            </div>
            
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept="image/*"
                className="hidden"
            />
            
            {error && <p className="text-red-500 text-xs font-bold mt-2">{error}</p>}
        </div>
    );
}